import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const ServicesSubPages = ({
  aboutHeading,
  aboutText,
  images = [],
  includedHeading,
  includedItems = [],
  customizedHeading,
  customizedItems = [],
}) => {
  return (
    <div className="container py-5">
      {/* About Section */}
      <div className="mb-5">
        <h3 className="fw-bold">{aboutHeading}</h3>
        <p>{aboutText}</p>
        <div className="row">
  {/* Main large image */}
  <div className="col-md-8 mb-3">
    <div style={{ height: '450px', overflow: 'hidden' }}>
      <img
        src={images[0]}
        alt="Main Service"
        className="img-fluid h-100 w-100 object-fit-cover rounded"
      />
    </div>
  </div>

  {/* Two smaller stacked images */}
  <div className="col-md-4">
    <div className="mb-3" style={{ height: '215px', overflow: 'hidden' }}>
      <img
        src={images[1]}
        alt="Sub Image 1"
        className="img-fluid h-100 w-100 object-fit-cover rounded"
      />
    </div>
    <div style={{ height: '215px', overflow: 'hidden' }}>
      <img
        src={images[2]}
        alt="Sub Image 2"
        className="img-fluid h-100 w-100 object-fit-cover rounded"
      />
    </div>
  </div>
</div>

      </div>

      {/* What's Included Section */}
      <div className="mb-5">
        <h4 className="fw-bold">{includedHeading}</h4>
        {includedItems.map((item, index) => (
          <div className="d-flex align-items-start mb-2" key={index}>
            <span className="text-danger me-2">✔️</span>
            <p className="mb-0">{item}</p>
          </div>
        ))}
      </div>

      {/* Customized Solution Section */}
      <div>
        <h4 className="fw-bold">{customizedHeading}</h4>
        {customizedItems.map((item, index) => (
          <div className="d-flex align-items-start mb-2" key={index}>
            <span className="text-danger me-2">✔️</span>
            <p className="mb-0">{item}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesSubPages;
